import client from './client';

/**
 * 반송률통계 일자별통계
 */
export const returnDayReport = (param) =>
  client.get(`/api/report/retrn/newday`, param);

/**
 * 반송률통계 광고주통계
 */
export const returnAdverReport = (param) =>
  client.get(`/api/report/retrn/newadver`, param);

/**
 * 반송률통계 매체통계
 */
export const returnMediaReport = (param) =>
  client.get(`/api/report/retrn/newmedia`, param);

/**
 * 반송률통계 지면별통계
 */
export const returnMcReport = (param) =>
  client.get(`/api/report/retrn/newmc`, param);
